/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Manage_BillingInputs */

const en_plan_manage_billing = /** @type {(inputs: Plan_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your billing details`)
};

const es_plan_manage_billing = /** @type {(inputs: Plan_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra tus datos de facturación`)
};

/**
* | output |
* | --- |
* | "Manage your billing details" |
*
* @param {Plan_Manage_BillingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_manage_billing = /** @type {((inputs?: Plan_Manage_BillingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Manage_BillingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_manage_billing(inputs)
	return en_plan_manage_billing(inputs)
});